import { Typography } from '@iheartjane/reefer';

export const PaymentSuccess = () => {
  return (
    <>
      <Typography variant="h1-semibold">Success!</Typography>
      <Typography mt={12}>
        You have completed your cashless payment for the reservation. You may
        close this screen.
      </Typography>
    </>
  );
};
